import React from 'react';
import WithOnlyOnDesktop from '../../../../components/onlyOnDesktop/withOnlyOnDesktop';
import FlexProfessionalCredentialsList from './FlexProfessionalCredentialsList';

import './FlexProfessionalCredentials.scss';

const FlexProfessionalCredentials = () => {
	return (
		<WithOnlyOnDesktop>
			<FlexProfessionalCredentialsList />
		</WithOnlyOnDesktop>
	);
};

export default FlexProfessionalCredentials;
